export default __webpack_public_path__ + "static/media/staticTrustPilotReview_03.b34d3243.jpg";